module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "sp",
    attrs: {
      "id": "ch4"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "cn"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("4")])]), _vm._v(" "), _c('p', {
    staticClass: "co"
  }, [_vm._v("Wolfe and Zack had fallen through a spring-loaded secret trapdoor in the stage. By the time Peter and the cops reached the basement, Wolfe had escaped through a back exit, while Zack was knocked out cold.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Damn it,” Peter said.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“We’ll take care of your friend,” one of the cops said. “Go finish your show.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Peter hurried back to the stage. The audience was still in their seats, waiting for the show to end. He asked a dozen people to stand up, and began to read their minds, calling out dates and anniversaries and anything else he could pull from their thoughts. By the time he was done, he was exhausted, and could barely speak.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The audience rewarded him with a standing ovation.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("As the crowd was filing out, more cops arrived. A pair of detectives led him to his dressing room. Their names were Sal Dagastino and Colleen Schoch, and they were straight out of a TV cop show. Short and annoying, Dagastino barked questions like a drill sergeant, while Schoch, who was pretty enough to be a runway model, said little.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Let me see if I’ve got this straight,” Dagastino said, scribbling in a notepad. “Wolfe tried to stab you. You blew flash paper into his face, and your assistant grabbed him. They started wrestling, and fell through a secret trapdoor. What’s that for?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“I make myself disappear during the show,” Peter said.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“I always wondered how that worked. Your assistant hit his head and was knocked out, which let Wolfe escape. That about sum it up?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Yes, detective.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Show me how the flash paper trick works.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“I’m not allowed to reveal my secrets. It’s the magician’s code.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Show me anyway.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Peter pulled the hand flasher from his pocket, and pulled the trigger. A blinding flash of white light appeared a few feet above their heads.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Pretty neat. I need to keep it … as evidence,” Dagastino said.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Peter handed him the device. One of his gifts was the ability to peer into the future. He saw Dagastino standing with a teenage boy who was his spitting image. Dagastino handed the boy the device, and he fired it off, burning his hand.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Don’t let your kid play with it,” Peter said without thinking.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Who told you I had a kid?” the detective asked, pocketing the device.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“No one. It’s what I tell everyone.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Thanks for the warning. Next question. Your assistant called 911 before Wolfe attacked you. Why did she do that?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Peter couldn’t tell Dagastino the truth without revealing he was a psychic. He hated lying to the detective, but saw no other choice.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Wolfe made some comments before the show that bothered me,” he said. “When Wolfe came on stage, I sensed he was going to cause trouble, so I told Liza to call 911.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“You sensed it?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“That’s right. His vibes were bad.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Dagastino scribbled away. Peter breathed a sigh of relief.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“How did Wolfe pay for his ticket? Credit card or cash?” Dagastino asked.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Someone came to the theater and paid cash. The ticket was waiting at will-call.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“So there’s no paper trail.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Peter shook his head.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Think you’d recognize Wolfe if you saw him again?” Dagastino asked.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Absolutely. We were as close as I am to you.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Dagastino produced a photograph from his jacket, which he passed to Peter. The photo showed Wolfe passing through an airport security check, and had the date and time stamped in the corner. It had been taken two days ago.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“This him?” the detective asked.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Yes. If you don’t mind my asking, who is he?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“I can’t tell you that.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Come on. He tried to kill me.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“I still can’t tell you.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Reading minds was hard when the subject wouldn’t play ball. Peter realized he was going to have to pull the information out of Dagastino one piece at a time.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“You’re searching for Wolfe, aren’t you?” Peter asked.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Dagastino flipped his notepad shut, and said nothing.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Wolfe’s a bad guy, isn’t he?” Peter went on.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Silence.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“A "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("real")]), _vm._v(" bad guy.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Dagastino looked confused, and glanced nervously at his partner.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“He slipped into the country a few days ago and shouldn’t have, and now every cop in New York is looking high and low for him,” Peter said.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Who the hell told you that?” Dagastino snapped.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“No one.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Then what are you, a mind reader?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Whatever gave you that idea.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Stop the wisecracks. Now, who gave you that information?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Peter felt himself starting to lose his temper. If he wasn’t careful, he was going to say something really stupid. He’d already taken enough of a risk talking to the detectives, and decided it was time to end the interview. He went to the door and twisted the handle.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“I’m sure you can find your way out,” he announced.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Are you throwing us out?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“That’s right. Have a nice night.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Dagastino left the dressing room in a huff. Instead of following him, Schoch stayed behind. She looked vaguely familiar, and Peter tried to determine where they’d met before.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Tell me why you did that,” Schoch said.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Your partner is a jerk. He had it coming to him.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Dag’s trying to do his job. Wolfe’s dangerous. You need to help us find him.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“How dangerous?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“I can’t tell you that.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("This was going nowhere. Wolfe was going to kill scores of people on Tuesday night if he wasn’t apprehended. Schoch impressed him as trustworthy, so Peter shut the door.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“I’m going to tell you something about myself that can go no further,” he said.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Schoch crossed her arms, and waited.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“I "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("am")]), _vm._v(" a mind reader. Earlier tonight, I read Wolfe’s mind. I know why he’s in New York. He’s planning an attack in Times Square on Tuesday night, right as the theaters let out.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Schoch uncrossed her arms. “You’re a mind reader?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“That’s right.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Excuse me, but that’s impossible.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“No it’s not. Think of a number, any number. Got one?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Yes…”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Two hundred and seventeen.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“How the hell did you do that?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“I read your mind. Now, listen to me. Wolfe is some kind of mass murderer. He won’t use guns or bombs or anything like that. People will simply fall down on the pavement, and die. Now tell me who Wolfe is. Maybe I can help you find him.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Schoch bit her lip, thinking about it. Trust ran both ways. She finally nodded.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“All right. Here’s what we know about the guy who attacked you. Wolfe is a member of a cult called the Order of Astrum that’s based out of the United Kingdom. Their symbol is tattooed on Wolfe’s neck. It got spotted in the surveillance photo Dag showed you.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“What kind of cult?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“They practice dark magic.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Any idea why he tried to kill me?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“No. Now tell me how the mind reading works. It sounds very useful.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“It’s a gift,” he explained. “I have to connect with a person to read their thoughts. Sometimes, all I get are bits and pieces of what they’re thinking.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“So Wolfe let you read his thoughts.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Yes. It was almost like he was testing me.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“If we find Wolfe, would you come down to the station, and read his mind?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Peter hesitated. This was exactly what had happened to his friend Nemo. Nemo had gone to help the police, and had done such a good job that he’d never been seen again.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Let me think about it,” he said.")]), _vm._v(" "), _c('p', {
    staticClass: "sb-std"
  }, [_vm._v("*   *   *")]), _vm._v(" "), _c('p', {
    staticClass: "sb2"
  }, [_vm._v("Peter escorted Schoch to the back exit of the theater. Telling her about his psychic abilities hadn’t been as difficult as he’d thought it would be. She was easy to talk to, and inspired trust. He opened the back door. A black Volvo was parked in the alley, Dagastino was at the wheel.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Tell your partner I’m sorry I pissed him off,” Peter said.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“I will.” Schoch paused. “You don’t remember me, do you?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("He plumbed her face. He "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("had")]), _vm._v(" met her before. But where?")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“I thought you looked familiar,” he admitted.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“I was the first officer on the scene when your parents died. I took care of you that night.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Peter felt like he’d been punched in the stomach. The memories came rushing back, and he envisioned Schoch in a dark blue uniform. “You took me to the station house, and fed me ice cream. You were very kind, although I’m afraid I wasn’t much help. The doctors said I repressed the memory of what happened.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“You tried very hard. I always appreciated that. I still think about the case.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“It’s been closed for a long time,” he said quietly.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Opening her purse, Schoch removed a business card, and stuck it into his hand. “Call me if you remember anything else about Wolfe that might be helpful.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“I’ll do that. Please don’t tell anyone what I told you,” he said.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“About the mind reading? Don’t worry. Your secret’s safe with me.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Not everyone could keep a secret, but the bond that had been cemented between them long ago told him that Schoch could be trusted. She walked outside and got into the waiting car.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Goodnight,” she called to him.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Peter glanced at her card. Schoch worked out of the 19th Precinct on the Upper East Side, not far from where he lived. This area of the city wasn’t in her jurisdiction, and he found himself wondering why she and her partner were here.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("As the Volvo pulled away, a strange thought occurred to him. Schoch had been there the night his parents had perished, and now she was here, questioning him about Wolfe. It was too much of a coincidence. The two events were somehow connected.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("He ran into the alley wanting to ask her, but the car was already gone.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ecbd406e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/chapter4.vue
// module id = 90
// module chunks = 0